import { useEffect, useState } from "react";
import { apiClient, ApiError } from "../../lib/api-client";

interface AdminTenant {
  id: string;
  slug: string;
  legal_name: string;
  trade_name: string;
  status: string;
  starts_at: string;
  ends_at: string;
}

export function AdminTenantsPage() {
  const [tenants, setTenants] = useState<AdminTenant[]>([]);
  const [form, setForm] = useState({ slug: "", legalName: "", tradeName: "", startsAt: "", endsAt: "" });
  const [message, setMessage] = useState<string | null>(null);

  function refresh() {
    apiClient.get<{ items: AdminTenant[] }>("/admin/tenants").then((data) => setTenants(data.items));
  }

  useEffect(refresh, []);

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    try {
      await apiClient.post("/admin/tenants", {
        ...form,
        startsAt: new Date(form.startsAt).toISOString(),
        endsAt: new Date(form.endsAt).toISOString(),
      });
      setMessage("Tenant criado.");
      refresh();
    } catch (err) {
      setMessage(err instanceof ApiError ? err.message : "Falha ao criar tenant.");
    }
  }

  return (
    <div>
      <h2>Tenants</h2>
      <form onSubmit={handleCreate} className="card" style={{ marginBottom: "var(--space-6)", maxWidth: 420 }}>
        <div className="field">
          <label htmlFor="slug">Slug</label>
          <input id="slug" required value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} />
        </div>
        <div className="field">
          <label htmlFor="legalName">Razão social</label>
          <input id="legalName" required value={form.legalName} onChange={(e) => setForm({ ...form, legalName: e.target.value })} />
        </div>
        <div className="field">
          <label htmlFor="tradeName">Nome fantasia</label>
          <input id="tradeName" required value={form.tradeName} onChange={(e) => setForm({ ...form, tradeName: e.target.value })} />
        </div>
        <div className="field">
          <label htmlFor="startsAt">Início de vigência</label>
          <input id="startsAt" type="date" required value={form.startsAt} onChange={(e) => setForm({ ...form, startsAt: e.target.value })} />
        </div>
        <div className="field">
          <label htmlFor="endsAt">Fim de vigência</label>
          <input id="endsAt" type="date" required value={form.endsAt} onChange={(e) => setForm({ ...form, endsAt: e.target.value })} />
        </div>
        {message && <p role="status">{message}</p>}
        <button className="btn" type="submit">
          Criar tenant
        </button>
      </form>

      <div className="card" style={{ overflowX: "auto" }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Slug</th>
              <th>Nome fantasia</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {tenants.map((tenant) => (
              <tr key={tenant.id}>
                <td>{tenant.slug}</td>
                <td>{tenant.trade_name}</td>
                <td>
                  <span className={`status-badge ${tenant.status === "active" ? "status-badge--paid" : "status-badge--negative"}`}>
                    {tenant.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
